///<reference path="../../../typings/api.d.ts" />

import API from "api";
import { HttpVerb } from "../../constants";

const getSessionTime = async () => {
  if (API)
    return (
      API &&
      API.authenticatedRequest({
        url: "/api/Timing/GetSessionTime/",
        method: HttpVerb.GET
      })
    );
};

export default {
  getSessionTime
};
